import { Component, OnInit, AfterViewInit, Input } from '@angular/core';

@Component({
	selector: 'app-component-scroll-title',
	templateUrl: './component.scroll-title.html',
	styleUrls: ['./component.scroll-title.css']
})

export class ComponentScrollTitleComponent implements OnInit {

  isShow: boolean;
	constructor(

	) {}

	ngOnInit() {

    setTimeout(()=>{
      this.isShow = true;
    },500);

    setTimeout(()=>{
      this.isShow = false;
    },2500);

	}


}



// WEBPACK FOOTER //
// ./src/app/scroll-title/component.scroll-title.ts